module.exports = __webpack_public_path__ + "img/isami.64ed87bb.jpg";